module.exports = __webpack_public_path__ + "static/media/centralHeating.cf796bfe.png";